import { mapAnchorTarget } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  Social = '.gtm-social',
  Accordion = '.gtm-accordion',
  CTA = '.gtm-press-center-cta',
}

const mapAccordion = ({ target }: { target: HTMLElement }) => {
  const containerEl =
    target && ((target as HTMLElement).closest(Selectors.Accordion) as HTMLElement);

  // Only available for accordion elements.
  if (!containerEl) {
    return undefined;
  }

  return containerEl;
};

export const mapTarget = ({ target }: any) => {
  const element = mapAnchorTarget({ target }) || mapAccordion({ target });

  return element;
};

export const onDatalayer = ({ target }: OnDatalayerProps) => {
  const isSocial = target?.classList.contains(Selectors.Social.replace('.', ''));
  const isAccordion = target?.classList.contains(Selectors.Accordion.replace('.', ''));
  const isCTA = target?.classList.contains(Selectors.CTA.replace('.', ''));
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  if (isSocial) {
    return {
      event: 'clickSocialMedia',
      eventCategory: 'Press Center',
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isAccordion) {
    return {
      event: 'clickAccordion',
      eventCategory: 'Press Center',
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isCTA) {
    return {
      event: 'clickCTA',
      eventCategory: 'Press Center',
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};
